import api from './api';

export const clientService = {
  // Get all clients
  getAllClients: async (filters = {}) => {
    const response = await api.get('/clients', { params: filters });
    return response.data;
  },

  // Get my assigned clients
  getMyClients: async (filters = {}) => {
    const response = await api.get('/clients/my-clients', { params: filters });
    return response.data;
  },

  // Get single client
  getClient: async (id) => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  // Create client
  createClient: async (clientData) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  // Update client
  updateClient: async (id, clientData) => {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  },

  // Update client status
  updateClientStatus: async (id, status, notes) => {
    const response = await api.patch(`/clients/${id}/status`, { status, notes });
    return response.data;
  },

  // Add interaction
  addInteraction: async (id, interactionData) => {
    const response = await api.post(`/clients/${id}/interaction`, interactionData);
    return response.data;
  },

  // Assign client to user
  assignClient: async (id, userId) => {
    const response = await api.patch(`/clients/${id}/assign`, { userId });
    return response.data;
  },

  // Delete client
  deleteClient: async (id) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  // Bulk import
  bulkImportClients: async (clients) => {
    const response = await api.post('/clients/bulk-import', { clients });
    return response.data;
  },

  // Get statistics
  getClientStats: async () => {
    const response = await api.get('/clients/stats');
    return response.data;
  }
};
